module.exports = __webpack_public_path__ + "img/1-3.7703c050.svg";